module.exports = ".container {\n  padding-top: 10px;\n  height: 200px;\n  background: white; }\n  .container a {\n    padding: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/page-not-found/page-not-found.component.scss
// module id = ./src/app/components/page-not-found/page-not-found.component.scss
// module chunks = main